import { SkillVersionsPanel } from '@/components/projects'
import { useSkillDetailContext } from '@/hooks'

export function SkillVersionHistoryPage() {
  const { projectId, skill, internalName, content } = useSkillDetailContext()

  return (
    <div className="h-full" data-testid="skill-version-history-section">
      <SkillVersionsPanel projectId={projectId} skill={skill} internalName={internalName} currentEditorContent={content} />
    </div>
  )
}
